module.exports = __webpack_public_path__ + "img/design-forward-stock-prices.5fc932d4.png";